export const ISSUE_CONTENT_PANEL_CUSTOMISED = 'issue.content.panel.customised.flag';
